import script from "./CurrentProviders.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentProviders.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentProviders.vue?vue&type=style&index=0&id=0d171bc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d171bc8"]])

export default __exports__